































































































































































































































































































import DraggableWrapper from '@/components/dashboard/DraggableWrapper.vue'
import QuantumDashboard from '@/components/dashboard/QuantumDashboard.vue'
import LoadItemMenu from '@/components/lookup/LoadItemMenu.vue'
import { genericErrorMessage } from '@/constants'
import { dashboardService } from '@/services'
import { AvailableChart, Dashboard, DashboardChart } from '@/types/DashboardServiceType'
import { MenuItems } from '@/types/utilTypes'
import { cloneDeep } from 'lodash'
import Vue from 'vue'

function generateInitialDeleteForm() {
    return {
        deleteDialog: false,
        loading: false,
        error: false,
        success: false,
        dashboard: {} as Dashboard
    }
}

function generateInitialUpsertForm() {
    return {
        loading: false,
        errors: {} as Record<string, string>,
        success: false
    }
}

export default Vue.extend({
    components: {
        QuantumDashboard,
        DraggableWrapper,
        LoadItemMenu
    },
    async mounted() {
        await this.getDefaultDashboard()
        await this.getAvailableDashboards()
    },
    data() {
        return {
            isEditMode: false,
            upsertForm: generateInitialUpsertForm(),
            dashboardLoading: false,

            dashboard: {
                id: '',
                title: '',
                isPublic: false,
                isDefault: false,
                charts: [] as DashboardChart[],
                isOwned: true,
            } as Dashboard,
            isDefaultDashboardSwitch: false,

            dashboards: {
                loading: false,
                owned: [],
                public: []
            } as MenuItems<Dashboard>,

            availableCharts: {
                isLoading: false,
                charts: [] as AvailableChart[]
            },

            deleteForm: generateInitialDeleteForm(),
            genericErrorMessage: genericErrorMessage
        }
    },
    methods: {
        canDeleteItem(item: any) {
            return !item.isDefault
        },
        deleteChart(index: number) {
            this.dashboard.charts.splice(index, 1)
        },
        resetFormState() {
            this.upsertForm = generateInitialUpsertForm()
            this.deleteForm = generateInitialDeleteForm()
        },
        async getDefaultDashboard(): Promise<void> {
            this.dashboardLoading = true
            var dashboard = await dashboardService.getDefaultDashboard()
            this.dashboard = dashboard
            this.isDefaultDashboardSwitch = dashboard.isDefault
            this.dashboardLoading = false
        },
        async onEditMode() {
            const newValue =  !this.isEditMode
            this.resetFormState()
            await this.getAvailableDashboards()

            if(!newValue) {
                await this.getDefaultDashboard()
            } else {
                await this.getAvailableCharts()
            }

            this.isEditMode = newValue
            
        },
        async getAvailableDashboards(): Promise<void> {
            this.dashboards.loading = true
            const dashboardsData = await dashboardService.getAvailableDashboards()
            this.dashboards.owned = dashboardsData.owned
            this.dashboards.public = dashboardsData.public
            this.dashboards.loading = false
        },
        async getAvailableCharts(): Promise<void> {
            this.availableCharts.isLoading = true
            this.availableCharts.charts = await dashboardService.getAvailableCharts()
            this.availableCharts.isLoading = false
        },
        async onSave() {
            try {
                this.upsertForm.loading = true
                this.upsertForm.errors = {}
                this.upsertForm.success = false

                const isDashboardDefault = this.isDefaultDashboardSwitch || !this.dashboard.hasDefault
                var dashboardId = await dashboardService.upsertDashboard({...this.dashboard, isDefault: isDashboardDefault})

                await this.getAvailableDashboards()
                await this.getAvailableCharts()

                const foundDashboard = this.dashboards.owned.find( dboard => dboard.id === dashboardId )
                
                if(dashboardId && foundDashboard) {
                    this.dashboard = foundDashboard
                    this.isDefaultDashboardSwitch = foundDashboard.isDefault
                } else {
                    throw new Error('Dashboard ID not returned from upsert')
                }

                this.upsertForm.success = true
            }
            catch (e) {
                if(this.axios.isAxiosError(e) && e?.response?.status == 400 && e.response.data && e.response.data.errors) {
                    for (const [key, value] of Object.entries(e.response.data.errors)) {
                        this.upsertForm.errors[key] = value as string
                    }
                    
                    this.upsertForm.errors.General = 'There are errors that require your attention'
                } else {
                    this.upsertForm.errors.General = genericErrorMessage
                }
            }
            this.upsertForm.loading = false
            
        },
        onAddChart() {
            this.dashboard.charts.unshift({
                id: Date.now().toString(),
                name: '',
                columns: 4,
                settings: {} as any,
                api: '',
                chartId: null
            })
        },
        onLoadDashboard(dashboard: Dashboard) {
            this.resetFormState()
            const dashboardIsDefault = dashboard.isOwned ? dashboard.isDefault : false
            this.dashboard = {
                ...cloneDeep(dashboard),
                id: dashboard.isOwned ? dashboard.id : '',
                isPublic: dashboard.isOwned ? dashboard.isPublic : false,
                isDefault: dashboardIsDefault
            }
            this.isDefaultDashboardSwitch = dashboardIsDefault
            
        },
        onChooseDeleteDashboard(dashboard: Dashboard) {
            this.deleteForm.dashboard = dashboard
            this.deleteForm.deleteDialog = true
        },
        onResetDashboardDeleteForm() {
            this.deleteForm = generateInitialDeleteForm()
        },
        async onDeleteDashboard() {
            this.deleteForm.loading = true
            this.deleteForm.error = false
            this.deleteForm.success = false

            try{ 
                await dashboardService.deleteDashboard(this.deleteForm.dashboard.id)
                this.deleteForm.success = true

                if(this.dashboard.id == this.deleteForm.dashboard.id) {
                    this.dashboard.id = ''
                }

                await this.getAvailableDashboards()
            } catch(e) {
                this.deleteForm.error = true
            }
            this.deleteForm.loading = false
        },
        async onNewDashboard() {
            this.dashboard = {
                id: '',
                title: '',
                isPublic: false,
                isDefault: false,
                charts: [] as DashboardChart[],
                hasDefault: this.dashboard.hasDefault,
                user: '',
                isOwned: true
            }
            this.isDefaultDashboardSwitch = false

            await this.onEditMode()
        }
    }
})
